import { Pipe, PipeTransform } from '@angular/core';
import { PrinterStatusMessage } from '../modules/control/knowledge/lane-control.knowledge';

const enum PrinterStatus {
  Connecting = 'connecting',
  Disconnected = 'disconnected',
  Ready = 'ready',
  Printing = 'printing',
  TicketHoldInMouth = 'ticketHoldInMouth',
  Error = 'error',
  Disabled = 'disabled',
  BetweenPrints = 'betweenPrints',
}

interface SensorResult {
  message: PrinterStatusMessage;
  sensorActive: boolean;
}

@Pipe({
  name: 'printerSensors',
})
export class PrinterStatusPipe implements PipeTransform {
  constructor() {}

  transform(sensorsState: any = null, _printerStatus: string = 'false'): any {
    let message = PrinterStatusMessage.Offline;

    const sensorsResult = this.processSensors(sensorsState);
    message = sensorsResult.message;

    if (!sensorsResult.sensorActive) {
      message = PrinterStatusMessage.Unknown; //DEFAULT MESSAGE
      if (sensorsState === null) message = PrinterStatusMessage.Offline;
      if (sensorsState?.printerStatus === PrinterStatus.Connecting) message = PrinterStatusMessage.Connecting;
      if (sensorsState?.printerStatus === PrinterStatus.Disconnected) message = PrinterStatusMessage.Offline;
      if (sensorsState?.printerStatus === PrinterStatus.Ready) message = PrinterStatusMessage.Online;
      if (sensorsState?.printerStatus === PrinterStatus.Printing) message = PrinterStatusMessage.Printing;
      if (sensorsState?.printerStatus === PrinterStatus.TicketHoldInMouth) message = PrinterStatusMessage.TicketHoldInMouth;
      if (sensorsState?.printerStatus === PrinterStatus.Error) message = PrinterStatusMessage.Error;
      if (sensorsState?.printerStatus === PrinterStatus.Disabled) message = PrinterStatusMessage.Disabled;
      if (sensorsState?.printerStatus === PrinterStatus.BetweenPrints) message = PrinterStatusMessage.LoadingPrinting;
    }

    return message;
  }

  private processSensors(sensorsState: any): SensorResult {
    let result: SensorResult = {
      message: undefined,
      sensorActive: false,
    };

    if (sensorsState !== null) {
      if (sensorsState?.state.paperjam === true) result.message = PrinterStatusMessage.PaperJam;
      if (sensorsState?.state.coveropened === true) result.message = PrinterStatusMessage.CoverOpened;
      if (sensorsState?.state.errorheadup === true) result.message = PrinterStatusMessage.ErrorHeadUp;
      if (sensorsState?.state.errheadtemp === true) result.message = PrinterStatusMessage.ErrorHeadTemp;
      if (sensorsState?.state.errcom === true) result.message = PrinterStatusMessage.ErrorCOM;
      if (sensorsState?.state.errnotack === true) result.message = PrinterStatusMessage.ErrorNoTack;
      if (sensorsState?.state.errcutter === true) result.message = PrinterStatusMessage.ErrorCutter;
      if (sensorsState?.state.cuttercoveropen === true) result.message = PrinterStatusMessage.CutterCoverOpened;
      if (sensorsState?.state.errram === true) result.message = PrinterStatusMessage.ErrorRAM;
      if (sensorsState?.state.erreeprom === true) result.message = PrinterStatusMessage.ErrorEPROM;
      if (sensorsState?.state.lfkey === true) result.message = PrinterStatusMessage.LFKey;
      if (sensorsState?.state.ffkey === true) result.message = PrinterStatusMessage.FFKey;

      if (sensorsState?.state.notchfound === true) result.message = PrinterStatusMessage.NotchFound;

      if (sensorsState?.state.virtualpaperend === true) result.message = PrinterStatusMessage.NearPaperEnd;
      //Importante el orden de estos 2 no cambiarlo
      if (sensorsState?.state.nearpaperend === true) result.message = PrinterStatusMessage.NearPaperEnd;
      if (sensorsState?.state.nopaper === true) result.message = PrinterStatusMessage.NoPaper;
      //Importante el orden
      if (sensorsState?.state.ticketmouth === true) result.message = PrinterStatusMessage.TicketHoldInMouth;

      if (result.message !== undefined) result.sensorActive = true;
      else result.message = PrinterStatusMessage.Offline;

      return result;
    }
    result.message = PrinterStatusMessage.Offline;

    return result;
  }
}
